module.exports = __webpack_public_path__ + "static/media/3P.27a7668d.svg";